"use client"

import { PropsWithChildren, useEffect, useState } from "react"
import clsx from "clsx"

export function ClientFadeIn(
  props: PropsWithChildren<{
    className?: string
    serverRender?: boolean
    enabled?: boolean
  }>,
) {
  const { serverRender = true, enabled = true } = props
  const [isVisible, setIsVisible] = useState(false)
  useEffect(() => {
    setIsVisible(true)
  }, [])
  if (!enabled) return props.children
  if (!serverRender && !isVisible) return null
  return (
    <div
      className={clsx([
        props.className,
        "transition-opacity duration-500",
        isVisible ? "opacity-100" : "opacity-0",
      ])}
    >
      {props.children}
    </div>
  )
}
